<template>
	<div class="blob-viewer w-full h-full">
		<div class="py-4 mr-2 flex" :style="`width: 900px`">
			<div class="flex w-1/2 justify-start">
				<img class="px-4 w-56 h-full" src="../assets/logo.svg" alt="IMD-CONNECT.PRO" />
			</div>
			<div class="w-1/2 flex justify-between">
				<div class="flex w-full gap-4">
					<div class="bg-connectProBlue px-2 py-1 rounded-full my-4">
						<font-awesome-icon v-if="blobUrl" :icon="['fas', 'minus']" class="text-white cursor-pointer" style="font-size: 18px" @click="zoomOut" />
					</div>
					<div class="bg-connectProBlue px-2 py-1 rounded-full my-4">
						<font-awesome-icon v-if="blobUrl" :icon="['fas', 'plus']" class="text-white cursor-pointer" style="font-size: 18px" @click="zoomIn" />
					</div>
				</div>
				<div class="flex gap-6 mr-6">
					<div class="bg-connectProBlue px-2 py-1 rounded-full my-4">
						<font-awesome-icon v-if="blobUrl" :icon="['fas', 'print']" class="text-white cursor-pointer" style="font-size: 18px" @click="printFile" />
					</div>
					<div class="bg-connectProBlue px-2 py-1 rounded-full my-4">
						<font-awesome-icon
							v-if="blobUrl"
							:icon="['fas', 'download']"
							style="font-size: 18px"
							class="text-white cursor-pointer"
							@click="downloadFile"
						/>
					</div>
				</div>
			</div>
		</div>
		<vue-pdf-embed v-if="blobUrl" :source="blobUrl" :width="documentWidth" ref="embeddedDocument"/>
		<iframe v-if="blobUrl" :src="blobUrl" width="100%" class="h-full hidden" id="iframeContent"></iframe>
		<p v-else>Lade Dokument...</p>
	</div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
	components: { VuePdfEmbed },
	data() {
		return {
			blobUrl: null,
			title: 'Dokument',
			documentWidth: 900,
		};
	},
	created() {
		// Die Blob-URL und den Titel aus den URL-Parametern abrufen
		const params = new URLSearchParams(window.location.search);
		this.blobUrl = params.get('blobUrl');
		this.title = params.get('title') || 'Dokument';
		document.title = this.title; // Setzt den Tab-Titel
	},
	methods: {
		zoomOut() {
			this.documentWidth = this.documentWidth - 200;
		},
		zoomIn() {
			this.documentWidth = this.documentWidth + 200;
		},
		downloadFile() {
			if (!this.blobUrl) return;
			fetch(this.blobUrl)
				.then(response => response.blob())
				.then(blob => {
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = this.title;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(link.href);
				})
				.catch(err => console.error('Fehler beim Download:', err));
		},
		printFile() {
			// this.$refs.embeddedDocument.print();
			// document.getElementById('embeddedDocument').focus();
			// document.getElementById('embeddedDocument').print();
			//	window.document.print();
			document.getElementById('iframeContent').contentWindow.print();
		},
	},
};
</script>

<style scoped>
.blob-viewer {
	text-align: center;
}

.styled-iframe {
	width: 50%;
	border: 2px solid #ccc;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
</style>
